/*
 * Copyright © 2023 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Component, Input, TemplateRef } from '@angular/core';

export type TooltipPosition = 'top' | 'left' | 'bottom' | 'right' | 'pointer';

/**
 * FC Tooltip component.
 */
@Component({
    selector: 'fc-tooltip',
    templateUrl: './fc-tooltip.component.html',
    styleUrls: ['./fc-tooltip.component.scss']
})
export class FcTooltipComponent {

    /**
     * Content of tooltip.
     */
    @Input() content: string | TemplateRef<any> = '';

    /**
     * Data of tooltip.
     */
    @Input() data: any;

    /**
     * Tooltip position.
     */
    @Input() position: TooltipPosition = 'top';

    /**
     * Left position.
     */
    @Input() left = 0;

    /**
     * Top position.
     */
    @Input() top = 0;

    /**
     * Is visible.
     */
    @Input() visible = false;

    /**
     * Tooltip container custom class.
     */
    @Input() tooltipClass = '';

    /**
     * Check if content is TemplateRef.
     *
     * @param content Tooltip content.
     * @returns Boolean.
     */
    isTemplateRef(content: any): content is TemplateRef<any> {
        return content instanceof TemplateRef;
    }
}
